<template>
  <div class="messages">
    <div class="mb-4">
      <h3 class="text-lg font-semibold mb-2">Notizen</h3>
      
      <div v-if="!showForm" class="mb-4">
        <button @click="showForm = true" class="btn btn-primary btn-small">
          + Neue Notiz
        </button>
      </div>
      
      <div v-if="showForm" class="mb-4 p-4 border border-gray-300 rounded">
        <message-form 
          :dossier="dossier" 
          :show-cancel="true"
          @message-created="onMessageCreated" 
          @cancelled="showForm = false">
        </message-form>
      </div>
    </div>

    <div v-if="messages.length === 0" class="text-gray-500 italic">
      Keine Notizen vorhanden.
    </div>

    <div v-for="message in sortedMessages" :key="message.id" class="message-item mb-3 p-3 border border-gray-200 rounded">
      <div v-if="editingMessageId !== message.id">
        <div class="message-content whitespace-pre-wrap">{{ message.message }}</div>
        <div class="message-meta text-sm text-gray-500 mt-2 flex justify-between items-center">
          <span>{{ formatDate(message.created_at) }} - {{ message.user.first_name }} {{ message.user.last_name }}</span>
          <div class="message-actions flex gap-2">
            <span @click="startEdit(message)" class="cursor-pointer text-blue-600 hover:text-blue-800">
              Bearbeiten
            </span>
            <message-delete 
              :message="message" 
              :dossier="dossier" 
              @message-deleted="onMessageDeleted">
              Löschen
            </message-delete>
          </div>
        </div>
      </div>
      
      <div v-else>
        <message-edit 
          :message="message" 
          :dossier="dossier" 
          @message-updated="onMessageUpdated" 
          @cancelled="editingMessageId = null">
        </message-edit>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dossier', 'initialMessages'],
  data() {
    return {
      messages: this.initialMessages || [],
      showForm: false,
      editingMessageId: null
    }
  },
  computed: {
    sortedMessages() {
      return this.messages.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    }
  },
  methods: {
    onMessageCreated: function (message) {
      this.messages.push(message)
      this.showForm = false
    },
    
    onMessageUpdated: function (updatedMessage) {
      const index = this.messages.findIndex(m => m.id === updatedMessage.id)
      if (index !== -1) {
        this.messages.splice(index, 1, updatedMessage)
      }
      this.editingMessageId = null
    },
    
    onMessageDeleted: function (deletedMessage) {
      const index = this.messages.findIndex(m => m.id === deletedMessage.id)
      if (index !== -1) {
        this.messages.splice(index, 1)
      }
    },
    
    startEdit: function (message) {
      this.editingMessageId = message.id
    },
    
    formatDate: function (dateString) {
      const date = new Date(dateString)
      return date.toLocaleString('de-DE')
    }
  }
}
</script>